import { Paper, withStyles, WithStyles, withTheme, WithTheme } from '@material-ui/core';
import * as React from 'react';

const styles = {

}

type Props = WithTheme & WithStyles;

export class About extends React.Component<Props, {}> {
	constructor(props: Props, context?: any) {
		super(props, context);
		// Here is some stuff.
	}
	public render() {
		return (
			<Paper color={'secondary'} style={{ color: '#f8f8f8', width: `${700}px`, height: '100%', background: `linear-gradient(to right, rgba(11, 11, 11, .8), rgba(11, 11, 11, 1) ${700 / 2}px, rgba(11, 11, 11, .8) ${700}px)`, backgroundSize: `${700}px 100%`, backgroundPosition: '50% 100%', backgroundRepeat: 'no-repeat', margin: '10px auto' }}>
				<div style={{ margin: '25px' }}>
					<div>Newt Industries is an indie game development team from Wisconsin.  We prioritize simple but deep mechanics, a holistic approach to art and music.  We like fun, too.</div>
					<div id="aboutTeamContainer">
						<div className="aboutTeamMember" id="aboutTeamMemberEkins">
							Ekins photo and info here.
					</div>
						<div className="aboutTeamMember" id="aboutTeamMemberAnderson">
							Anderson photo and info here.
					</div>
					</div>
				</div>
			</Paper>
		);
	}
}

export default withTheme()(withStyles(styles)(About));


// WEBPACK FOOTER //
// ./src/components/About.tsx